(() => {
  if (window.drboAutumnCampaignReady) return;
  window.drboAutumnCampaignReady = true;
  const copy = {
    de: {
      active: "Die Herbst-Angebote enden in",
      ended: "Diese Aktion ist beendet.",
      timer: "Zeit bis zum Aktionsende",
      heading: "Die SunEnergyXT 500-Serie entdecken.",
      body: "Vergleiche Modelle und Sets. Es gelten die aktuellen Angaben auf der jeweiligen Produktseite.",
      button: "Sets ansehen "
    },
    en: {
      active: "Autumn offers end in",
      ended: "This promotion has ended.",
      timer: "Time until the promotion ends",
      heading: "Explore the SunEnergyXT 500 series.",
      body: "Compare models and sets. The current information on each product page applies.",
      button: "View sets "
    }
  };
  const refresh = () => {
    document.querySelectorAll("[data-autumn-hero]").forEach(hero => {
      const end = Date.parse(hero.dataset.end);
      const status = hero.querySelector("[data-autumn-status]");
      const digits = hero.querySelector("[data-autumn-digits]");
      if (!Number.isFinite(end)) {
        digits.hidden = true;
        return;
      }
      const text = copy[hero.dataset.locale] || copy.de;
      const now = Date.now();
      const expired = now >= end;
      const state = expired ? "ended" : "active";
      if (hero.dataset.state !== state) {
        hero.dataset.state = state;
        status.textContent = expired ? text.ended : text.active;
        digits.setAttribute("aria-label", text.timer);
      }
      digits.hidden = expired;
      if (expired) {
        hero.querySelector(".drbo-autumn-hero__heading").textContent = text.heading;
        hero.querySelector(".drbo-autumn-hero__text").textContent = text.body;
        hero.querySelector(".drbo-autumn-hero__button").firstChild.textContent = text.button;
      } else {
        const seconds = Math.max(0, Math.floor((end - now) / 1000));
        const values = {
          days: Math.floor(seconds / 86400),
          hours: Math.floor(seconds / 3600) % 24,
          minutes: Math.floor(seconds / 60) % 60,
          seconds: seconds % 60
        };
        Object.entries(values).forEach(([unit, value]) => {
          const field = hero.querySelector(`[data-autumn-${unit}]`);
          const next = String(value).padStart(2, "0");
          if (field.textContent !== next) field.textContent = next;
        });
      }
    });
  };
  refresh();
  window.setInterval(() => { if (!document.hidden) refresh(); }, 1000);
  document.addEventListener("visibilitychange", refresh);
  document.addEventListener("shopify:section:load", refresh);
})();
